import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.png";
import image4 from "../assets/t-image4.png";
import image6 from "../assets/t-image6.png";
import image7 from "../assets/t1.jpg";
import image8 from "../assets/t2.jpg";
import image9 from "../assets/t3.jpg";
import image10 from "../assets/t4.jpg";
import image11 from "../assets/t5.jpg";
import image12 from "../assets/t6.jpg";
import image13 from "../assets/t7.jpg";
import image14 from "../assets/t8.jpg";
import image15 from "../assets/t9.jpg";
import image16 from "../assets/t10.jpg";

export const testimonialsData = [
  {
    image: image1,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image2,
    review: "",
    name: "Kadınlara Özel Çalışma Alanı",
    status: "",
  },

  {
    image: image4,
    review: "",
    name: "",
    status: "",
  },

  {
    image: image6,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image7,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image8,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image9,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image10,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image11,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image12,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image13,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image14,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image15,
    review: "",
    name: "",
    status: "",
  },
  {
    image: image16,
    review: "",
    name: "",
    status: "",
  },
];
